import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { IKeyValue } from '../i2g-ng-utils.data';

export const months: List<IKeyValue> = List([
  {
    key: 'DATE.MONTH.JANUARY',
    value: 1,
  },
  {
    key: 'DATE.MONTH.FEBRUARY',
    value: 2,
  },
  {
    key: 'DATE.MONTH.MARCH',
    value: 3,
  },
  {
    key: 'DATE.MONTH.APRIL',
    value: 4,
  },
  {
    key: 'DATE.MONTH.MAY',
    value: 5,
  },
  {
    key: 'DATE.MONTH.JUNE',
    value: 6,
  },
  {
    key: 'DATE.MONTH.JULY',
    value: 7,
  },
  {
    key: 'DATE.MONTH.AUGUST',
    value: 8,
  },
  {
    key: 'DATE.MONTH.SEPTEMBER',
    value: 9,
  },
  {
    key: 'DATE.MONTH.OCTOBER',
    value: 10,
  },
  {
    key: 'DATE.MONTH.NOVEMBER',
    value: 11,
  },
  {
    key: 'DATE.MONTH.DECEMBER',
    value: 12,
  },
]);

export function monthsLocalized(
  _translateService: TranslateService
): List<IKeyValue> {
  return months.map(
    (month: IKeyValue): IKeyValue => {
      return {
        key: _translateService.instant(month.key),
        value: month.value,
      };
    }
  ) as List<IKeyValue>;
}
